export var types = {
    GET_ALL_CHOICE_GROUPS: 'GET_ALL_CHOICE_GROUPS',
    SET_CHOICE_GROUP_OPTIONS: 'SET_CHOICE_GROUP_OPTIONS',
};
export var getChoiceGroups_AC = function (choiceGroupsList) {
    return {
        type: types.GET_ALL_CHOICE_GROUPS,
        payload: choiceGroupsList,
    };
};
export var setChoiceGroups_AC = function (data) {
    return {
        type: types.SET_CHOICE_GROUP_OPTIONS,
        payload: data,
    };
};
//# sourceMappingURL=choiceGroup.js.map